<template>
  <div style="padding: 24px;background: #fff;">
    <router-view></router-view>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less" scoped>
</style>
